import request from "@/utils/request";

export function registerUser(username, password,phone) {
  const data = {
    username,
    password,
    phone
  };
  return request({
    url: "/api/users/register",
    method: "post",
    data
  });
}

export function isPhoneExisted(phone) {
  return request({
    url: "/api/users/phone",
    method: "get",
    params: { phone }
  });
}
